export default __webpack_public_path__ + "static/media/lunch2.d3079dc3.jpg";